import React from 'react';

import CloseButton from '../Buttons/CloseButton';

export default function TitleWithDeleteButton({ title, onDelete }) {
  return (
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-lg font-bold leading-6 text-gray-900">{title}</h3>
      {onDelete && <CloseButton onClick={onDelete} />}
    </div>
  );
}
